import axios from './BaseConfig';
import { IStripePayment } from './interfaces/IStripe';
import {
  IExamAnswerBody,
  IExamAnswerResult,
  IExamInfo,
  IExamWithQuestions,
  ICertificateItem,
  IExamCertificateResponse,
} from './interfaces/IExam';

//interface
import { MySessions } from './interfaces/MySessions';
import { IGetCertificate, SessionParams } from './interfaces/SessionParams';

export const getSessions = async (params: SessionParams) => {
  try {
    const res = await axios.get('/sessions', { params });
    return res.data.results;
  } catch (e) {
    console.log('error', e);
  }
};

export const getSessionsById = async (id: string) => {
  try {
    const res = await axios.get(`/sessions/${id}`);
    return res.data;
  } catch (e) {
    console.log('error', e);
  }
};

export const postSessionByIdUser = async (id: string, idSession: string, email:string) => {
  try {
    const res = await axios.post(`/users/${id}/sessions/${idSession}`,{ email:email });
    return res;
  } catch (e) {
    console.log('error', e);
  }
};

export const getUserSessions = async (id: number, params: MySessions) => {
  try {
    const res = await axios.get(`/users/${id}/sessions`, { params });
    return res.data.results;
  } catch (e) {
    console.log('error', e);
  }
};

export const postStripePayment = async (body:IStripePayment) => {
     return await axios.post(`/payments/register`, { ...body });
};

export const getCertificate = async ( params:IGetCertificate)=>{ 
  return await axios.get('/sessions/pdf', {
    params:{
      ...params
    }
   });
}

// 1. Get exam info for a module
export const getExamInfo = async (
  idBasis: string | number,
  idModule: string | number
) => {
  try {
    const res = await axios.get<IExamInfo>(
      `/basis/${idBasis}/modules/${idModule}/exam`
    );
    return res.data;
  } catch (e) {
    console.log('error', e);
  }
};

// 2. Get questions and pre-built answers of a specific exam
export const getExamQuestions = async (
  idBasis: string | number,
  idModule: string | number,
  idExam: string | number
): Promise<IExamWithQuestions | undefined> => {
  try {
    const res = await axios.get<IExamWithQuestions>(
      `/basis/${idBasis}/modules/${idModule}/exam/${idExam}`
    );
    return res.data;
  } catch (e) {
    console.log('error', e);
  }
};

// 3. Store answers and get the result
export const postExamAnswers = async (
  idBasis: string | number,
  idModule: string | number,
  idExam: string | number,
  body: IExamAnswerBody
): Promise<IExamAnswerResult | undefined> => {
  try {
    const res = await axios.post<IExamAnswerResult>(
      `/basis/${idBasis}/modules/${idModule}/exam/${idExam}/answer`,
      body
    );
    return res.data;
  } catch (e) {
    console.log('error', e);
  }
};

// Fire-and-forget submit on page unload (refresh/close) - uses fetch keepalive
export const postExamAnswersOnUnload = (
  idBasis: string | number,
  idModule: string | number,
  idExam: string | number,
  body: IExamAnswerBody
): void => {
  const baseURL = `${process.env.REACT_APP_API_BASE_URL}/v1`;
  const token = localStorage.getItem('token');
  const url = `${baseURL}/basis/${idBasis}/modules/${idModule}/exam/${idExam}/answer`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    keepalive: true,
  });
};

// 4. Get exam certificate (PDF/image base64)
export const getExamCertificate = async (
  idBasis: string | number,
  idModule: string | number
): Promise<IExamCertificateResponse | undefined> => {
  try {
    const res = await axios.get<IExamCertificateResponse>(
      `/basis/${idBasis}/modules/${idModule}/certificate`
    );
    const data = res.data;
    // Prefer base64Img (JPEG) over base64 (PDF) for share/download
    const base64 = data?.base64Img ?? data?.base64;
    return base64 ? { base64 } : undefined;
  } catch (e) {
    console.log('error', e);
  }
};

// 5. Get certificates (approved exams)
export const getCertificates = async (
  userId: string | number
): Promise<ICertificateItem[] | undefined> => {
  try {
    const res = await axios.get<ICertificateItem[]>(
      `/users/${userId}/certificates`
    );
    return res.data;
  } catch (e) {
    console.log('error', e);
  }
};

